import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpRequestInterceptorService } from './http-request-interceptor.service'
import { HTTP_INTERCEPTORS } from '@angular/common/http'

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptorService,
      multi: true
    }
  ]
})
export class HttpRequestInterceptorModule {
}
